<template>
  <div>
    <v-menu class="hidden-md-and-up" offset-y v-show="true">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon fab dark id="btn-cart" class="btn-cart">
          <!-- <v-icon color="#292D32" dark> mdi-cart </v-icon> -->

          <v-img src="@/assets/images/cart.svg" alt="cart" style="object-fit: contain; max-width: 50%">
          </v-img>

          <span v-if="cart.length > 0" class="cart-badge"
            style="font-size: 25px; font-weight: bold; color: #4caf4f; margin: 5px">{{ cart.length }}</span>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item class="mb-2" :key="index" router v-for="(product, index) in cart"
          :to="generateDynamicRoute(product)">
          <v-list-item-avatar>
            <v-img :src="product.image"></v-img>
          </v-list-item-avatar>

          <v-list-item-content style="max-width: 400px">
            <v-list-item-title class="mb-1">
              <strong>{{ `${product.category} - ${product.name}` }}</strong>
            </v-list-item-title>
            <small class="mb-1">
              <b> Phone: </b>
              {{
              product.profile.phone
              ? product.profile.phone
              : product.profile.phone1 | formatPhone("MX")
              }}</small>
            <small class="mb-1">
              <b> Schedules: </b>
              {{ product.profile.servicehours }}</small>
            <small class="mb-1">
              <b> Reservation Date: </b>
              {{ product.reservation.date }}</small>
            <small class="mb-1">
              <b> Reservation Hour: </b>
              {{ product.reservation.hour }}</small>
          </v-list-item-content>

          <v-list-item-icon>
            <v-btn @click="removeItem(index)" :style="{
                marginTop: $vuetify.breakpoint.smAndDown ? '25%' : '10%',
              }">
              <v-icon> mdi-delete</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item>
          <v-btn block color="success" dark @click="openReservationForm" v-if="cart.length">
            Make a reservation
          </v-btn>

          <v-list-item-title v-else>
            You have no reservations
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog v-model="reservationFormDialog" max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">Reservation Form</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="reservationFormRef">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="reservationForm.name" label="Name" :rules="[
                    (v) => !!v || 'Name is required',
                    (v) =>
                      /^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(v) ||
                      'Only letters and spaces allowed',
                  ]"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="reservationForm.surnames" label="Last name" :rules="[
                    (v) => !!v || 'Last name are required',
                    (v) =>
                      /^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(v) ||
                      'Only letters and spaces allowed',
                  ]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="reservationForm.phone" label="Phone"
                  :rules="[(v) => /^[0-9]+$/.test(v) || 'Only numbers allowed']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="reservationForm.email" label="Email" :rules="[
                    (v) => !!v || 'Email is required',
                    (v) => /.+@.+\..+/.test(v) || 'Invalid email format',
                  ]"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="reservationForm.gender" label="Gender"
                  :items="['Male', 'Female', 'Nonbinary', 'Other']"
                  :rules="[(v) => !!v || 'Gender is required']"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="reservationForm.origin" label="Origin" :rules="[
                    (v) => !!v || 'Origin is required',
                    (v) =>
                      /^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(v) ||
                      'Only letters and spaces allowed',
                  ]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field type="number" v-model="reservationForm.accompanying_guests" label="Accompanying Guests"
                  :rules="[(v) => /^[0-9]+$/.test(v) || 'Only numbers allowed']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field type="number" v-model="reservationForm.stay_duration" label="Stay Duration (Days)"
                  :rules="[(v) => /^[0-9]+$/.test(v) || 'Only numbers allowed']"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="reservationForm.visit_purpose" label="Visit Purpose"
                  :items="['Medical', 'Pleasure', 'Business']"
                  :rules="[(v) => !!v || 'Visit Purpose is required']"></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="closeReservationForm">Cancel</v-btn>
          <v-btn color="success" @click="submitReservationForm">Send Reservation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackBar" :timeout="2000">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="snackBar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import CartService from "@/providers/CartService";

export default {
  name: "Cart",

  data: () => ({
    cart: [],

    reservationFormDialog: false,
    reservationForm: {
      name: "",
      surnames: "",
      phone: "",
      email: "",
      relations: {},
      reservations: [],
      gender: "",
      origin: "",
      accompanying_guests: "",
      stay_duration: "",
      visit_purpose: "",
      email_entity: "",
      name_entity: "",  
    },
    defaultValue: {
      name: "",
      surnames: "",
      phone: "",
      email: "",
      relations: {},
      reservations: [],
      gender: "",
      origin: "",
      accompanying_guests: "",
      stay_duration: "",
      visit_purpose: "",
      email_entity: "",
      name_entity: "",
    },

    snackBar: false,
    snackText: "",
  }),

  filters: {
    formatPhone(phn, country) {
      // console.log('phn:', phn);
      if (phn == "undefined" || phn == null || phn === "") {
        return country;
      }
      switch (country) {
        case "US":
          return (
              "USA +1 (" +
              phn.substring(0, 3) +
              ") " +
              phn.substring(3, 6) +
              "-" +
              phn.substring(6)
          );
        case "MX":
          return (
              "MEX +52 (" +
              phn.substring(0, 3) +
              ") " +
              phn.substring(3, 6) +
              "-" +
              phn.substring(6)
          );
        default:
          return country;
      }
    },
  },
  watch: {
    cart() {
      const button = document.getElementById('btn-cart')
      button.classList.add('btn-expand')
      setTimeout(() => {
        button.classList.remove('btn-expand');
      }, 1000);
    }
  },
  methods: {

    openReservationForm() {
      this.reservationFormDialog = true;
    },

    closeReservationForm() {
      this.reservationFormDialog = false;
    },

    pluralizeCategory(category) {
      const pluralMap = {
        Hospital: "hospitales",
        Clinic: "clinics",
        Doctor: "doctors",
        Restaurant: "restaurants",
        Leisure: "leisures",
        Hotel: "hotels",
        Pharmacy: "pharmaceutics",
        Laboratory: "laboratories",
        Transport: "transportations",
        Vineyard: "vineyards",
        House: "houses",
        AssitingLiving: "assiting_livings"
      };

      return pluralMap[category] || category.toLowerCase() + "s";
    },

    submitReservationForm() {
      if (this.$refs.reservationFormRef.validate()) {
        const relations = {};

        this.cart.forEach((product) => {
          const category = this.pluralizeCategory(product.category);
          const profileId = product.profile.id;

          if (!relations[category]) {
            relations[category] = [];
          }

          relations[category].push(profileId);
          this.reservationForm.reservations.push(product.reservation);
        });

        this.reservationForm.relations = relations;

        // Lógica para enviar el formulario si pasa la validación

        CartService.addCart(this.reservationForm);

        // console.log("Formulario enviado:", this.reservationForm);

        // limpiar cart

        this.$store.dispatch("clearCart");
        this.cart = this.$store.getters.getCart;

        // Cierra el diálogo después de enviar el formulario
        this.closeReservationForm();

        this.snackText =
            "Your itinerary has been successfully sent to the email provided";

        this.snackBar = true;
      }
    },

    generateDynamicRoute(product) {
      const categoryMap = {
        Hospital: "hospital-profile",
        Clinic: "clinic-profile",
        Doctor: "doctor-profile",
        Restaurant: "restaurant-profile",
        Leisure: "leisure-profile",
        Hotel: "hotel-profile",
        Pharmacy: "pharmaceutic-profile",
        Laboratory: "laboratory-profile",
        Transport: "transportation-profile",
        Vineyard: "vineyard-profile",
        House: "house-profile",
      };

      const category = product.category;
      const profileId = product.profile.id;

      if (category in categoryMap) {
        return `/${categoryMap[category]}/${profileId}`;
      }
    },

    removeItem(index) {
      this.$store.dispatch("removeFromCart", index);
    },
  },

  mounted() {
    this.cart = this.$store.getters.getCart;
  },
};
</script>
<style scoped>
.btn-cart {
  padding: 2px;
  background-color: rgb(242, 242, 242);
  height: 60px;
  width: 60px;
  border: 1px solid #d4cfcf;
  transition: transform 1s ease
}

.btn-expand {
  transform: scale(1.2); /* Aumenta el tamaño en 1.2 veces */
}
</style>
